module.exports = __webpack_public_path__ + "img/a3.64148699.png";